/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";

/**
 * Standard error response object
 */
export type DeleteApiLeadScraperMicroserviceApiV1JobsJobIdErrorResponseData = {
  error: string;
  code?: string | undefined;
  details?: any | null | undefined;
};

/**
 * Standard error response object
 */
export class DeleteApiLeadScraperMicroserviceApiV1JobsJobIdErrorResponse
  extends Error
{
  error: string;
  code?: string | undefined;
  details?: any | null | undefined;

  /** The original data that was passed to this error instance. */
  data$: DeleteApiLeadScraperMicroserviceApiV1JobsJobIdErrorResponseData;

  constructor(
    err: DeleteApiLeadScraperMicroserviceApiV1JobsJobIdErrorResponseData,
  ) {
    const message = "message" in err && typeof err.message === "string"
      ? err.message
      : `API error occurred: ${JSON.stringify(err)}`;
    super(message);
    this.data$ = err;

    this.error = err.error;
    if (err.code != null) this.code = err.code;
    if (err.details != null) this.details = err.details;

    this.name = "DeleteApiLeadScraperMicroserviceApiV1JobsJobIdErrorResponse";
  }
}

/** @internal */
export const DeleteApiLeadScraperMicroserviceApiV1JobsJobIdErrorResponse$inboundSchema:
  z.ZodType<
    DeleteApiLeadScraperMicroserviceApiV1JobsJobIdErrorResponse,
    z.ZodTypeDef,
    unknown
  > = z.object({
    error: z.string(),
    code: z.string().optional(),
    details: z.nullable(z.any()).optional(),
  })
    .transform((v) => {
      return new DeleteApiLeadScraperMicroserviceApiV1JobsJobIdErrorResponse(v);
    });

/** @internal */
export type DeleteApiLeadScraperMicroserviceApiV1JobsJobIdErrorResponse$Outbound =
  {
    error: string;
    code?: string | undefined;
    details?: any | null | undefined;
  };

/** @internal */
export const DeleteApiLeadScraperMicroserviceApiV1JobsJobIdErrorResponse$outboundSchema:
  z.ZodType<
    DeleteApiLeadScraperMicroserviceApiV1JobsJobIdErrorResponse$Outbound,
    z.ZodTypeDef,
    DeleteApiLeadScraperMicroserviceApiV1JobsJobIdErrorResponse
  > = z.instanceof(DeleteApiLeadScraperMicroserviceApiV1JobsJobIdErrorResponse)
    .transform(v => v.data$)
    .pipe(z.object({
      error: z.string(),
      code: z.string().optional(),
      details: z.nullable(z.any()).optional(),
    }));

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace DeleteApiLeadScraperMicroserviceApiV1JobsJobIdErrorResponse$ {
  /** @deprecated use `DeleteApiLeadScraperMicroserviceApiV1JobsJobIdErrorResponse$inboundSchema` instead. */
  export const inboundSchema =
    DeleteApiLeadScraperMicroserviceApiV1JobsJobIdErrorResponse$inboundSchema;
  /** @deprecated use `DeleteApiLeadScraperMicroserviceApiV1JobsJobIdErrorResponse$outboundSchema` instead. */
  export const outboundSchema =
    DeleteApiLeadScraperMicroserviceApiV1JobsJobIdErrorResponse$outboundSchema;
  /** @deprecated use `DeleteApiLeadScraperMicroserviceApiV1JobsJobIdErrorResponse$Outbound` instead. */
  export type Outbound =
    DeleteApiLeadScraperMicroserviceApiV1JobsJobIdErrorResponse$Outbound;
}
